<p-dialog #selectFormDialog
          [(visible)]="visible"
          *ngIf="visible && (allDefinitions.length > 1)"
          (onHide)="cancel()"
          [modal]="true"
          [closable]="true"
          [draggable]="false"
          [style]="{ 'max-width': '450px', width: '100%' }"
          styleClass="center-header m-dialog-header-text"
          [contentStyle]="{'overflow': 'visible'}"
          header="Please select a Form">
    <div class="mt-3">
        <div class="inputs-group" [style.max-width]="'100%'">
            <div class="inputs-group-row">
                <label class="inputs-group-row-name">Tags:</label>
                <div class="inputs-group-row-value">
                    <p-multiSelect placeholder="Select Tags"
                                   *miproLoading="loadingTags"
                                   [options]="tagOptions"
                                   [showClear]="true"
                                   (onClear)="onTagsChanged(null)"
                                   (onChange)="onTagsChanged($event)">
                    </p-multiSelect>
                </div>
            </div>
            <div class="inputs-group-row">
                <label class="inputs-group-row-name asterisk-mark">Form:</label>
                <div class="inputs-group-row-value">
                    <p-dropdown #formDropdown
                                *miproLoading="loadingDefinitions"
                                [(ngModel)]="selectedDefinitionId"
                                [options]="definitionDropdownOptions"
                                [showClear]="true"
                                placeholder="Select Form">
                    </p-dropdown>
                </div>
            </div>
        </div>

        <form-buttons [disabled]="!selectedDefinitionId" [config]="buttonsConfig"></form-buttons>
    </div>
</p-dialog>


<multi-user-form-create-instance-dialog
    *ngIf="displayMufCreateInstanceDialog"
    [episodeId]="this.currentEpisode ? this.currentEpisode.id: null"
    [patientId]="currentPatientId"
    [walkInId]="walkInId"
    [multiUserFormDef]="currentMUFDef"
    (onCancel)="onCancelMufInstanceDialog()"
    (onCreate)="onCreateMufInstanceDialog($event)">
</multi-user-form-create-instance-dialog>

<!-- TODO: move this dialog to a separate component. -->
<p-dialog [(visible)]="displayNewFormRequestDialog" [style]="{'max-width': '450px', width: '100%'}"
          header="New Form Request" [modal]="true" [closable]="true" (onHide)="cancelPublish()">
    <div class="inputs-group">
        <div class="inputs-group-row">
            <label class="inputs-group-row-name">Groups:</label>
            <div class="inputs-group-row-value">
                <p-multiSelect [(ngModel)]="selectedTargetGroups"
                               [options]="targetGroups"
                               optionLabel="label"
                               dataKey="value"
                               id="targetGroups"
                               name="targetGroups"
                               placeholder="Select groups">
                </p-multiSelect>
            </div>
        </div>
        <div class="inputs-group-row">
            <label class="inputs-group-row-name">Users:</label>
            <div class="inputs-group-row-value">
                <p-multiSelect [(ngModel)]="selectedTargetUsers"
                               [options]="targetUsers"
                               optionLabel="label"
                               dataKey="value"
                               appendTo="body"
                               id="targetUsers"
                               name="targetUsers"
                               placeholder="Select users">
                </p-multiSelect>
            </div>
        </div>

        <div class="buttons-panel buttons-panel-top-margin">
            <button
                pButton
                type="button"
                label="Cancel"
                class="p-button-secondary"
                (click)="cancelRequest()"></button>
            <button
                pButton
                type="button"
                (click)="Request()"
                label="Create request"></button>
        </div>
    </div>
</p-dialog>
